import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root'
})
export class ImpressDecorationLocationCodeService {
  private baseUrl = environment.baseUrl + '/ImpressDecorationLocationCode';

  constructor(private http: HttpClient) { }

  getAll(): Observable<any> {
    return this.http.get(`${this.baseUrl}/GetAll`).pipe(
      map(response => {
        if (Array.isArray(response)) {
          return response.map(code => ({
            impressDecorationLocationCodeId: code.ImpressDecorationLocationCodeId,
            code: code.Code,
            description: code.Description,
            parentSide: code.ParentSide,
            isActive: code.IsActive,
            isDeleted: code.IsDeleted,
            createdDate: code.CreatedDate,
            createdBy: code.CreatedBy,
            modifiedDate: code.ModifiedDate,
            modifiedBy: code.ModifiedBy
          }));
        }
        return response;
      })
    );
  }

  create(data: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/Create`, data);
  }

  update(data: any): Observable<any> {
    return this.http.put(`${this.baseUrl}/Update/${data.impressDecorationLocationCodeId}`, data);
  }
}
